import { Check } from "lucide-react";
import Reveal, { Eyebrow } from "@/components/Reveal";
import { TIMELINE, IMAGES } from "@/data/content";

export default function PlanningTimeline() {
  return (
    <section
      id="planning"
      data-testid="planning-section"
      className="bg-ocean/[0.07] border-y border-slateblue/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-28 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <div className="relative">
            <div className="rounded-3xl overflow-hidden border-4 border-white shadow-[0_32px_64px_-24px_rgba(16,42,67,0.3)]">
              <img
                src={IMAGES.planning}
                alt="A traveler mapping out an itinerary"
                className="h-[420px] sm:h-[520px] w-full object-cover"
                data-testid="planning-image"
              />
            </div>
            <div className="absolute -bottom-6 -right-4 sm:-right-6 rounded-2xl bg-gold text-navy px-6 py-4 shadow-xl">
              <p className="font-serif text-lg leading-tight">What to book —<br />and when.</p>
            </div>
          </div>
        </Reveal>
        <div>
          <Reveal>
            <Eyebrow>Trip Planning</Eyebrow>
            <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl text-navy leading-tight">
              The travel planning timeline
            </h2>
            <p className="mt-4 text-base text-charcoal/75 leading-relaxed">
              What to book 90, 60, and 30 days before departure — a calm sequence that keeps the fun in the trip
              and the panic out of it.
            </p>
          </Reveal>
          <div className="mt-10 space-y-4">
            {TIMELINE.map((t, i) => (
              <Reveal key={t.day} delay={i * 0.1}>
                <div
                  data-testid={`timeline-${t.day}`}
                  className="group flex gap-6 rounded-2xl bg-white border border-slateblue/15 p-6 transition-[border-color,box-shadow] duration-500 hover:border-gold/40 hover:shadow-lg"
                >
                  <div className="shrink-0 text-center">
                    <p className="font-serif text-4xl text-gold leading-none">{t.day}</p>
                    <p className="mt-1 font-mono text-[10px] tracking-[0.24em] uppercase text-slateblue">days out</p>
                  </div>
                  <div className="border-l border-slateblue/15 pl-6">
                    <h3 className="font-serif text-xl text-navy">{t.title}</h3>
                    <ul className="mt-3 space-y-1.5">
                      {t.items.map((item) => (
                        <li key={item} className="flex items-start gap-2 text-sm text-charcoal/70">
                          <Check className="h-4 w-4 text-gold shrink-0 mt-0.5" />
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
